import * as React from "react";
import {Text, View, Alert, TouchableWithoutFeedback} from "react-native";
import {Input, Modal, Button as ButtonUI} from "@ui-kitten/components";
import {FontAwesome5} from "@expo/vector-icons";
import {AsyncButtonWithSpinner} from "../../../shared/async-button-with-spinner";
import {GooglePlacesAutocomplete} from "react-native-google-places-autocomplete";
import {Button} from '../../../shared/button'
import * as Location from 'expo-location'
import {ModalLayout} from "../../../shared/modal-layout";
// import MapView from 'react-native-maps';

export const UpdateUserForm = ({user, onSubmit, submitLabel, submitButtonAppearance}) => {
    const [isOnAddressSelection, setOnAddressSelection] = React.useState('hide')
    const [showFlowAlert, setShowFlowAlert] = React.useState(false)

    const [username, setUserName] = React.useState(user.username)
    const [phoneNumber, setPhoneNumber] = React.useState(user.phone_number)
    const [address, setAddress] = React.useState(user.address)
    const [latitude, setLatitude] = React.useState(user.latitude)
    const [longitude, setLongitude] = React.useState(user.longitude)

    const formData = {username, phone_number: phoneNumber, address, latitude, longitude}


    const isValid = (username && username != '') && (phoneNumber && phoneNumber != '') && (address && address != '') && latitude && longitude

    return <>

        <View style={{marginBottom: 10}}>
            <Text>Name</Text>
            <Input value={username} onChangeText={setUserName}/>
        </View>
        <View style={{marginBottom: 10}}>
            <Text>Email</Text>
            <Input value={user.email} disabled={true} autoCompleteType="email"
                   accessoryLeft={() => <FontAwesome5 name="check" size={24} color="green"/>}/>
        </View>
        <View style={{marginBottom: 10}}>
            <Text>Phone Number</Text>
            <Input value={phoneNumber} onChangeText={setPhoneNumber} autoCompleteType="tel" keyboardType="number-pad"
                   accessoryLeft={() => <Text>+230</Text>}/>
        </View>
        <View style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10}}>
            <Text>Address</Text>
            <Button onWhite={true} appearance="ghost" onPress={() => setShowFlowAlert(true)}>{address == '' ? 'Enter' : 'Edit'}</Button>
        </View>
        <TouchableWithoutFeedback  onPress={() => setShowFlowAlert(true) }>
            <View>
                <Input placeholder={address} placeholderTextColor={'black'} multiline={true} disabled={true} />
            </View>
        </TouchableWithoutFeedback>


        <View style={{marginBottom: 10, marginTop: 15}}>
            <AsyncButtonWithSpinner onWhite={true} disabled={!isValid} appearance={submitButtonAppearance}
                                    onPress={() => onSubmit(formData)}>{submitLabel}</AsyncButtonWithSpinner>
        </View>

        {showFlowAlert && <ModalLayout close={() => setShowFlowAlert(false)}>
            <Text style={{textAlign: 'center', marginBottom: 10}}>Are you currently at home ?</Text>
            <View style={{flexDirection: 'row', justifyContent: 'space-evenly'}}>
                <AsyncButtonWithSpinner onWhite={true} mainColor='#1e7a4f' onPress={async () => {
                    let { status } = await Location.requestForegroundPermissionsAsync();
                    if (status === 'granted')  {
                        let location = await Location.getCurrentPositionAsync({});
                        setAddress("My home")
                        setLatitude(location.coords.latitude)
                        setLongitude(location.coords.longitude)
                    }
                    else {
                        setOnAddressSelection('address')
                    }
                    setShowFlowAlert(false)
                }}>Yes</AsyncButtonWithSpinner>
                <Button onWhite={true} mainColor='#1e7a4f' onPress={() => {
                    setOnAddressSelection('address')
                    setShowFlowAlert(false)
                }}>No</Button>
            </View>
        </ModalLayout>}

        {isOnAddressSelection !== 'hide' && <ModalLayout close={() => setOnAddressSelection('hide')}
               backdropStyle={{backgroundColor: '#000000b3'}}
               style={{position: 'absolute', top: 50, bottom: 30, left: 30, right: 30}}>
            <View style={{height: 500}}>
                <GooglePlacesAutocomplete
                    textInputProps={{
                        autoFocus: true
                    }}
                    placeholder='Find my address'
                    styles={{
                        container: {backgroundColor: 'white'}
                    }}
                    query={{
                        key: 'AIzaSyAdyQS1dDvzswosJfuDlsww7qdZVzzRFZQ',
                        language: 'en',
                        components: 'country:mu'
                    }}
                    requestUrl={{
                        useOnPlatform: 'web', // or "all"
                        url: 'https://cors-anywhere.herokuapp.com/https://maps.googleapis.com/maps/api', // or any proxy server that hits https://maps.googleapis.com/maps/api
                    }}
                    fetchDetails={true}
                    onPress={(data, detail) => {
                        setOnAddressSelection('hide')
                        setAddress(data.description)
                        setLatitude(detail.geometry.location.lat)
                        setLongitude(detail.geometry.location.lng)
                    }}
                    enablePoweredByContainer={false}
                />
            </View>
        </ModalLayout>}

    </>
}